import { useMemo } from 'react';

import {
  type DateTimeContextProps,
  useDateTimeContext,
} from '@rtkwlf/fenrir-react';

import { TIMEZONE_LOCAL } from 'ae-constants/constants';

export const useDateFormat = (
  format?: DateTimeContextProps['format'],
  overrideUtcFormat?: boolean,
) => {
  const { timezone, format: formatFromContext } = useDateTimeContext();

  return useMemo(() => {
    if (timezone === TIMEZONE_LOCAL || overrideUtcFormat) {
      return format ?? formatFromContext;
    }

    return 'logDateTime';
  }, [format, formatFromContext, overrideUtcFormat, timezone]);
};
